import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import Sidebar from '../../Components/Sidebar/Index.js'
import Card from '../../Components/Card/Index.js'
import { AddIcon } from '../../Svg/Index.js'
import { SET_INBOX } from '../../Actions/Chat'
import { SET_TYPE, SET_PROFILE_OPEN } from '../../Actions/Sidebar'
import Navbar from '../../Components/Navbar/Index.js'
import ProfileTrigger from '../../Components/ProfileTrigger/Index.js'
import Loader from '../../Components/Loader/Index.js'


class Messages extends Component {

    state = {
		messages: [],
		isNewChat: false,
        threadId: null,
        feedLoading: false
	}


    UNSAFE_componentWillMount() {
        
        const { user, inbox } = this.props;
        if(!user.token) {
            this.props.history.push('/')
        }
        if(!inbox.length) {
            this.setState({
                feedLoading: true
            })
        }
        this.props.actions.SET_INBOX().then(()=> {
            this.setState({
                feedLoading: false
            })
        })
    }

    changeType = (type) => {
        this.props.actions.SET_TYPE(type)
        this.props.actions.SET_PROFILE_OPEN(false);

    }

    componentDidMount() {
        document.body.classList.add('has-background');
    }

    componentWillUnmount() {
        document.body.classList.remove('has-background');
    }

    render() {
        const { inbox } = this.props
        const { feedLoading } = this.state
        
        return (
            <>
                <div className="o-page-wrap">
                    
                    <Sidebar />
                    <Navbar />
                    <ProfileTrigger />

                    {
                        feedLoading && (
                            <Loader />
                        )
                    }

                    <div className="o-main-container">
                        <h1>Inbox</h1>
                        <div className="c-feed">
                            {
                                inbox.length > 0 && (
                                    Object.keys(inbox).map((key, val) => 
                                        <Card 
                                            key={`chat-int-${key}`}
                                            author={inbox[key].user.display_name}
                                            authorImage={inbox[key].user.avatar.user_avatar}
                                            createdAt={inbox[key].first_message.created_at_for_humans}
                                            body={inbox[key].first_message.body}
                                            uuid={inbox[key]._uuid}
                                            user={inbox[key].user}
                                            unread={inbox[key].unread}
                                            type='chat'
                                        />
                                    )
                                )
                            }      

                            <div className="o-main-container__center">
                                <button className="c-btn c-btn--primary c-btn--compact c-btn--bottom-float js-share-button" onClick={() => this.changeType('chats') }>
                                    <span className="c-btn__icon"><AddIcon /></span>Nieuwe chat
                                </button>
                            </div>               
                        </div>
                        
                        
                    </div>
                </div>
            </>
        )
    }
}
const mapStateToProps = state => {
    return {
        user: state.user.user,
        inbox: state.chat.inbox
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({SET_INBOX, SET_TYPE, SET_PROFILE_OPEN}, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Messages))